import React, { useEffect, useState } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePost } from '~/contexts/PostContext'
import { useSiteVideoQuery } from "~/hooks/useSiteVideoQuery"
import { notBlank, jnstyls } from '~/utils/helpers'

import VideoControls from '~/components/video/controls'
import VideoNoControl from '~/components/video/no-controls'

import * as bstyle from "~/styles/blog/blog.module.scss"


const BlogVideo = ({ blockId, index }) => {
  const { isMobile } = useTheme()
  const { post } = usePost()
  
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const [video, setVideo] = useState(null)

  const desk_vid = settings.vidprod
  let mobi_vid = settings.mobi_vidprod ? settings.mobi_vidprod : false
  if (!mobi_vid && desk_vid) mobi_vid = desk_vid

  const desk_video_item = useSiteVideoQuery(desk_vid)
  const desk_ratio = desk_video_item?.media?.size?.ratio
  const mobi_video_item = useSiteVideoQuery(mobi_vid)
  const mobi_ratio = mobi_video_item?.media?.size?.ratio

  const find_video = () => {
    const handle = !isMobile ? desk_vid : mobi_vid
    setVideo(handle)
  }

  let page_styles = ''
  const block_attr = `[block="${block.id}"]`
  if (desk_ratio) {
    page_styles += `
      @media only screen and (min-width: 820px) {
        ${block_attr} {
          aspect-ratio: ${desk_ratio} auto;
        }
      }
    `
  }
  if (mobi_ratio) {
    page_styles += `
      @media only screen and (max-width: 819px) {
        ${block_attr} {
          aspect-ratio: ${mobi_ratio} auto;
        }
      }
    `
  }

  useEffect(() => {
    if (isMobile === null) return
    if (!(desk_vid || mobi_vid)) return
    find_video()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile])

  return (
    <div 
      className={jnstyls([
        bstyle.video, bstyle.sec, 
        index === 0 ? bstyle.first : '', 
        settings.stretch ? bstyle.wide_video : ''
      ])} 
      block={block.id}
    >
      {notBlank(page_styles) && (<style dangerouslySetInnerHTML={{ __html: page_styles}} />)}

      {(video && !settings.hide_controls) && (
        <VideoControls 
          handle={video}
          par_styles={''} 
          loopAuto={settings.loop_auto}
        />
      )}
      {(video && settings.hide_controls) && (
        <VideoNoControl 
          handle={video}
          par_styles={``}
        />
      )}
    </div>

  )
}

export default BlogVideo

